import { Injector, ElementRef } from '@angular/core';
import { LocalizationService } from 'abp-ng2-module/dist/src/localization/localization.service';
import { PermissionCheckerService } from 'abp-ng2-module/dist/src/auth/permission-checker.service';
import { FeatureCheckerService } from 'abp-ng2-module/dist/src/features/feature-checker.service';
import { SettingService } from 'abp-ng2-module/dist/src/settings/setting.service';
import { MessageService } from 'abp-ng2-module/dist/src/message/message.service';
import { AbpMultiTenancyService } from 'abp-ng2-module/dist/src/multi-tenancy/abp-multi-tenancy.service';
import { FormGroup } from '@angular/forms';
import { AppConsts } from '../../src/shared/AppConsts';
import { AppToasterService } from '../../src/shared/service/app-toaster.service';
import { AccountService, AlertService, } from './_services';

export abstract class AppComponentBase {

    localizationSourceName = AppConsts.localization.defaultLocalizationSourceName;

    localization: LocalizationService;
    permission: PermissionCheckerService;
    feature: FeatureCheckerService;
    notify: AppToasterService;
    setting: SettingService;
    message: MessageService;
    multiTenancy: AbpMultiTenancyService;
    elementRef: ElementRef;
    acctService : AccountService

    constructor(injector: Injector) {
        this.localization = injector.get(LocalizationService);
        this.permission = injector.get(PermissionCheckerService);
        this.feature = injector.get(FeatureCheckerService);
        this.notify = injector.get(AppToasterService);
        this.setting = injector.get(SettingService);
        this.message = injector.get(MessageService);
        this.multiTenancy = injector.get(AbpMultiTenancyService);
        this.elementRef = injector.get(ElementRef);
        this.acctService = injector.get(AccountService);      
    }

    l(key: string, args: any[] = null): string {
        let localizedText = this.localization.localize(key, this.localizationSourceName);

        if (!localizedText) {
            localizedText = key;
        }

        if (!args || !args.length) {
            return localizedText;
        }

        args.unshift(localizedText);
        return abp.utils.formatString.apply(this, args);
    }

    trimFormValue(formGroup: FormGroup, controlName: string, value: any){
        formGroup.controls[controlName].setValue(value.target.value.trim());
    }

    get defaultCurrency() {
        return AppConsts.currency;
    }

    get defaultCurrencySign() {
        return AppConsts.currencySign;
    }
    isGranted(permissionName: string): boolean {
        return abp.auth.isGranted(permissionName);
    }
    // isGranted(permissionName: string): boolean {
        
    //     return this.permission.isGranted(permissionName);
    // }
}


